import { InjectedConnector } from '@web3-react/injected-connector'
// TODO: set to real chain ids
export const injected = new InjectedConnector({ supportedNetworks: [1, 3, 4, 5, 42, 1337] })
